/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";

function getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsUrl(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/parcels` as const,
  };
  return res;
}

/**
 * @description Retorna as parcelas do plano (com valor ou com serial) com status da grid, multa, descontos, link de NFe autorizada, flags de integração bancária (Fealq/Vanzolini/Fusp/PecegePay) e indicadores de boleto gerado e recorrência de cartão. Ordenadas por tipo e número da parcela. Migrado do legado IndividualPayment/LoadGridDataAsyncParcels. **(Requer Authorization para autenticação)**
 * @summary Retorna as parcelas do plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels}
 */
export async function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsUrl(
      financialPersonId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
